<main #mainElement (click)="troggleOptionBox($event)" class="options-component"></main>

<ng-template cdkPortal #templateAppend="cdkPortal">
	@if (options.length > 0) {
		<div class="options-component-cdk-main-div">
			@for (option of options; track option) {
				<div class="opt-margin">
					<div (mousedown)="selectOption(option)" class="opt-option">
						{{ option.label }}
					</div>
				</div>
			}
		</div>
	}
</ng-template>
